import React, { Component } from 'react';

import { LOOM_URI } from 'constants/routes';

import './styles.less';

class FacebookDropdownItem extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  render() {
    return (
      <li className="share-video-facebook-dropdown-item" onClick={this.onClick}>
        <div className="icon" />
        <span>Facebook</span>
      </li>
    );
  }

  async onClick() {
    const { currentUserIsOwner, video } = this.props;

    const relationToVideo = currentUserIsOwner ? 'recorded via' : 'saw on';

    await new Promise(resolve => {
      window.fbReady(resolve);
    });

    window.FB.ui({
      method: 'share',
      display: 'popup',
      quote: `Check out this video I ${relationToVideo} Loom.`,
      href: `${LOOM_URI}/share/${video.id}`,
    });

    if (this.props.onClick) {
      this.props.onClick();
    }
  }
}

export default FacebookDropdownItem;
